import axios from "axios";
export const AxiosCont = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL
});
